import { Table } from 'antd';
import styled from '@emotion/styled';

// 605px is the height of a table with 10 rows. Just trying to keep a consistent height.
// There is probably a better way to do this but this seems to work ok for now.
const StyledTable = styled(Table)`
  .ant-table-container {
    min-height: 605px;
    tbody {
    }
  }
`;

const SearchResultsTable = ({
  columns,
  data,
  loading,
  emptyText,
  ...tableProps
}) => {
  return (
    <StyledTable
      locale={{
        emptyText,
      }}
      columns={columns}
      dataSource={data}
      size="medium"
      loading={loading}
      {...tableProps}
    />
  );
};

export default SearchResultsTable;
